export interface BasicMeasurement {
  weight: number;
  height?: number;
  sittingHeight?: number;
  scope?: number;
  footHeight?: number;
  wingspan?: number;
  standingHeight?: number;
  observationsControl?: string;
}

export interface ControlMeasurement {
  weight: number;
  height?: number;
  observationsControl?: string;
}

export interface DiameterMeasurement {
  anteroposteriorChest: number;
  biacromial: number;
  transverseChest: number;
  biIliocrestide: number;
  humera: number;
  femoral: number;
  wrist: number;
  ankle: number;
  hand: number;
}

export interface FoldMeasurement {
  abdominal: number;
  calf: number;
  medialThigh: number;
  subscapular: number;
  supraSpinal: number;
  triceps: number;
  wrist: number;
  tobill: number;
  hand: number;
  bicep: number;
  iliacCrest: number;
}

export interface PerimeterMeasurement {
  flexedArm: number;
  maxHip: number;
  maximumCalf: number;
  maximumForearm: number;
  maximumThigh: number;
  mediumThigh: number;
  minimumWaist: number;
  relaxedArm: number;
  thoraxMesoSternal: number;
  head: number;
  neck: number;
  wrist: number;
  omphalicAbomina: number;
  minimumAnkle: number;
}

export interface SegmentalLengthsAndHeightsMeasurement {
  foot: number;
  iliospinalHeight: number;
  medialStyloidFingerprint: number;
  radialAcromial: number;
  radialStyloid: number;
  tibialLateralHeight: number;
  tibialMedialMaleolarMedial: number;
  trocantereaHeight: number;
  trochanterFibialLat: number;
}

export interface BioODexaMeasurement {
  id: number;
  kgMlg: number;
  mg: number;
  mlgPercentile: number;
  mgPercentile: number;
  imlgOverT: number;
  imgOverT: number;
  bioODexaSubType: string;
  kgMMgPercentile: number;
  immOverT: number;
  kgMM: number;
}

export interface BasicEvaluationType {
  id: number;
  description?: string;
}

export interface EvaluationType {
  id: number;
  description?: string;
  key?: string;
}

export class EvaluationTypes {
  static COMPLETE: EvaluationType = {
    id: 2,
    description: 'FA5C Completo',
    key: 'FULL',
  };
  static REDUCE: EvaluationType = {
    id: 2,
    description: 'FA5C Reducido',
    key: 'REDUCED',
  };
  static CONTROL: EvaluationType = {
    id: 2,
    description: 'FA5C Control',
    key: 'CONTROL',
  };
  static CONTROL_WEIGHT: EvaluationType = {
    id: 2,
    description: 'Control de Peso',
    key: 'SIMPLE',
  };
  static FOLDS: EvaluationType = {
    id: 2,
    description: 'Suma de 6 pl',
    key: 'FOLD',
  };
  static BIOEXA: EvaluationType = {
    id: 2,
    description: 'BIA o DXA',
    key: 'BIO_O_DEXA',
  };
  static All: EvaluationType[] = [
    EvaluationTypes.COMPLETE,
    EvaluationTypes.REDUCE,
    EvaluationTypes.CONTROL,
    EvaluationTypes.FOLDS,
    EvaluationTypes.CONTROL_WEIGHT,
    EvaluationTypes.BIOEXA,

  ];
}

export interface EvaluationSummary {
  id: number;
  measurementDate: string;
  type: EvaluationType;
  weight: string;
  size: string;
  skinfolds?: [];
}

export interface FoldsEvaluation {
  basicMeasurement: BasicMeasurement;
  foldMeasurement: FoldMeasurement;
}

export interface ControlEvaluation extends FoldsEvaluation {
  perimeterMeasurement: PerimeterMeasurement;
}

export interface ReducedEvaluation extends ControlEvaluation {
  diameterMeasurement: DiameterMeasurement;
}

export interface BioODexaEvaluation {
  basicMeasurement: BasicMeasurement;
  bioODexaMeasurement: DiameterMeasurement;
}

export interface Evaluation {
  basicMeasurement?: BasicMeasurement;
  diameterMeasurement?: DiameterMeasurement;
  foldMeasurement?: FoldMeasurement;
  controlMeasurement?: ControlMeasurement;
  perimeterMeasurement?: PerimeterMeasurement;
  segmentalLengthsAndHeightsMeasurement?: SegmentalLengthsAndHeightsMeasurement;
  bioODexaMeasurement?: BioODexaMeasurement;
}

export enum EvaluationShowType {
  NONE = "NONE",
  FA5C = "FA5C",
  FA2C = "FA2C",
  MIX = "MIX"
}


export interface IPersonEvaluationFA5C {
  evaluationId: number;
  name: string;
  surname: string;
  personId: number;
  evaluationDate: string;
  comparerBody: IComparerBody;
}

export interface IComparerBody {
  fatMassKg: number;
  height: number;
  iMO: number;
  muscleMassKg: number;
  summarySixFold: number;
  weight: number;
}
